module.exports = __webpack_public_path__ + "media/clink.cfd9d35a.mp3";